var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoofB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 116,
    viewBox: "0 0 98 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.4974 17.048V9.97412H81.5156L81.5156 26.9748",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8615 5.40869H82.1562V9.97391H67.8615V5.40869Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7728 44.151V107.968H9.23438V44.1499",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2097 35.2495H37.8008V50.2244H60.2097V35.2495Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1178 71.6904H20.9648V91.8434H41.1178V71.6904Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0397 71.6904H56.8867V91.8434H77.0397V71.6904Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8802 44.1215L49.0043 11.9807L8.93127 44.1396C7.49694 45.2823 4.15346 45.57 2.65158 43.6208C1.10548 41.6141 2.55864 38.4171 3.99297 37.2744L47.7486 2.42708C48.5427 1.79449 49.4669 1.79449 50.261 2.42708L94.0167 37.2744C95.45 38.4171 96.8744 41.5915 95.3581 43.6208C93.8393 45.6533 90.3185 45.2606 88.8802 44.1215Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23809 107.967H88.7734V115H9.23809V107.967Z",
    stroke: "#8E9AA5",
    strokeWidth: 2,
    strokeMiterlimit: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoofB);
export default __webpack_public_path__ + "static/media/roof-b.00b38291e569d49f7c8aff280833c715.svg";
export { ForwardRef as ReactComponent };